export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_03.236d2a00.jpg";